import _Result from "antd/es/result";
import _Divider from "antd/es/divider";
import _Tag from "antd/es/tag";
import _Checkbox from "antd/es/checkbox";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useEffect, useState } from 'react';
import { css } from 'emotion';
import styled from '@emotion/styled';
import isEqual from 'lodash/isEqual';
import { getLocalText } from '../utilities/language';
import { scrollToTop } from '../utilities/pageLogic';
import IconFont from '@/components/common/IconFont';
import LotteryBox from './Lottery';
var aReg = /JumpTarget=parent.*target>/g;
var needIdReg = /need_survey_id/g;

// eslint-disable-next-line
export default (function (props) {
  var _lottery_v3$prizes;
  var res = props.res,
    finishImgUrl = props.finishImgUrl,
    finishImgScale = props.finishImgScale,
    prePrompt = props.realPrompt,
    title = props.title,
    type = props.type,
    did = props.did,
    uid = props.uid,
    errorCode = props.errorCode,
    device = props.device,
    showLotteryPage = props.showLotteryPage;
  var lottery_url = res.lottery_url,
    lottery_v3 = res.lottery_v3,
    response_id = res.response_id,
    score_analysis = res.score_analysis,
    exam_pass = res.exam_pass,
    hide_analysis_header = res.hide_analysis_header;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    showAna = _useState2[0],
    setShowAna = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    showLottery = _useState4[0],
    setShowLottery = _useState4[1];
  var _useState5 = useState(''),
    _useState6 = _slicedToArray(_useState5, 2),
    realPrompt = _useState6[0],
    setPrompt = _useState6[1];
  useEffect(function () {
    var resultIconBox = document.querySelector('.ant-result-icon');
    var mask = document.createElement('div');
    mask.className = 'iconMask';
    resultIconBox.appendChild(mask);

    // FIXME: 根据约定关键字JumpTarget=parent修改a的target属性
    setPrompt(prePrompt ? prePrompt.split('<a href=').reduce(function (acc, cur, i) {
      // FIXME: 根据约定关键字need_survey_id拼接uid/did
      var ids = "user_id=".concat(uid, "&device_id=").concat(did);
      var polyCur = needIdReg.test(cur) ? cur.replace(needIdReg, ids) : cur;
      return aReg.test(cur) ? acc.concat(i ? '<a href=' : '', polyCur.replace('target>', "target=\"_parent\">")) : acc.concat(i ? '<a href=' : '', polyCur);
    }, '') : '');
    setTimeout(function () {
      if (type === 'success') {
        mask.style.width = 0;
      } else {
        mask.style.height = 0;
      }
    }, 100);
  }, []);
  function showAnswerAnalysis(e) {
    e.preventDefault();
    setShowAna(true);
    setTimeout(function () {
      scrollToTop();
    }, 0);
  }
  function hideAnswerAnalysis() {
    setShowAna(false);
  }
  function getRichOption(_ref) {
    var option = _ref.option,
      img = _ref.img,
      video = _ref.video,
      audio = _ref.audio,
      _ref$scale = _ref.scale,
      scale = _ref$scale === void 0 ? 1 : _ref$scale;
    return option ? option.concat(img ? "<img src=".concat(img, " alt='img' style=\"zoom:").concat(scale, "\" loading='lazy'/>") : '').concat(audio ? "<audio src=".concat(audio, " controls />") : '').concat(video ? "<video src=".concat(video, " controls />") : '') : '';
  }
  function getRichOptions(options) {
    return options.map(function (opt) {
      return getRichOption(opt);
    });
  }
  function getQuestionAnalysis(question) {
    var _question$score = question.score,
      score = _question$score === void 0 ? '-' : _question$score,
      _question$total = question.total,
      total = _question$total === void 0 ? '-' : _question$total,
      _question$option_answ = question.option_answers,
      option_answers = _question$option_answ === void 0 ? [] : _question$option_answ,
      _question$text_answer = question.text_answers,
      text_answers = _question$text_answer === void 0 ? [] : _question$text_answer,
      question_type = question.question_type,
      _question$text_answer2 = question.text_answer,
      text_answer = _question$text_answer2 === void 0 ? '' : _question$text_answer2; // [本题得分: 0/10]
    var prefix = total ? ' ['.concat(getLocalText('this-question-score'), ': ', score, '/', total, '] ') : '';
    var isFillin = /fillin/.test(question_type);
    var selected = option_answers.filter(function (el) {
      return el.selected;
    });
    var correct = isFillin ? text_answers.map(function (e) {
      return e.correct_text_answer;
    }) : option_answers.filter(function (el) {
      return el.correct;
    });

    // （你的答案:）B
    var selectedText = isFillin ? text_answer : getRichOptions(selected).join('\n');

    // (正确答案:) A
    var correctText = isFillin ? correct.join(' | ') : getRichOptions(correct).join('\n');
    return {
      prefix: prefix,
      selectedText: selectedText,
      correctText: correctText,
      selected: selected,
      correct: correct
    };
  }
  function getOptionAnalysis() {
    var optionAnswers = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    /**
     * <checkBox> xxxx: xxx解析
     * <checkBox> xxxx: xxx解析
     */
    return React.createElement("div", null, optionAnswers.map(function (opt, i) {
      var analysis = opt.option_analysis,
        option = opt.option,
        correct = opt.correct;
      return React.createElement("div", {
        key: option,
        className: "marginBottom10"
      }, React.createElement(_Checkbox, {
        checked: correct,
        disabled: true,
        className: "marginRight5"
      }, React.createElement("span", {
        style: {
          color: 'var(--text-color)'
        }
      }, option, " ", !!analysis && ': ')), React.createElement("span", {
        style: {
          display: 'inline-block',
          color: 'var(--text-color)'
        },
        dangerouslySetInnerHTML: {
          __html: analysis
        }
      }));
    }));
  }
  function getQuestId() {
    var pathname = window.location.pathname.replace(/\/$/, '');
    if (pathname === '/') return;
    var ret = pathname.split('/'); // pathname一般都是 '/iGHria' 或 '/q/10666/DS4ut1N2/12c5/'
    if (!ret) return null;
    var id;
    if (ret[1] === 'q' || ret[1] === 'b') {
      id = ret[3]; // 问卷hash id
    } else {
      id = ret[1] || '';
    }
    return id.includes('preview') ? null : id;
  }
  function openLottery() {
    setShowLottery(true);
    showLotteryPage();
  }
  var unique_str = getQuestId();
  var lotteryParams = {
    response_id: response_id,
    did: did,
    uid: uid,
    unique_str: unique_str
  };
  return showAna ? React.createElement(AnalysisBox, {
    id: "analysisBox"
  }, !hide_analysis_header && React.createElement("div", {
    className: "flex alignCenter marginBottom20"
  }, React.createElement("div", {
    onClick: hideAnswerAnalysis,
    className: "pointer",
    style: {
      position: 'absolute'
    }
  }, React.createElement(IconFont, {
    type: "icon-left2-01"
  }), getLocalText('back')), React.createElement("h2", {
    style: {
      margin: '0 auto'
    }
  }, getLocalText('answer-analysis'))), (score_analysis || []).map(function (question, index) {
    var _getQuestionAnalysis = getQuestionAnalysis(question),
      prefix = _getQuestionAnalysis.prefix,
      selectedText = _getQuestionAnalysis.selectedText,
      correctText = _getQuestionAnalysis.correctText,
      selected = _getQuestionAnalysis.selected,
      correct = _getQuestionAnalysis.correct;
    var analysis = question.analysis,
      _question$option_answ2 = question.option_answers,
      option_answers = _question$option_answ2 === void 0 ? [] : _question$option_answ2,
      _question$text_answer3 = question.text_answers,
      text_answers = _question$text_answer3 === void 0 ? [] : _question$text_answer3,
      question_name = question.question_name,
      question_index = question.question_index,
      hide_question_no = question.hide_question_no,
      question_type = question.question_type;
    var isFillin = /fillin/.test(question_type);
    var goodJob = (correct === null || correct === void 0 ? void 0 : correct.length) ? isFillin ? text_answers.find(function (e) {
      return e.user_hit;
    }) : isEqual(selected, correct) : true; // 出题没设置正确答案的话，填什么都算对
    var noOptionAnalysis = !option_answers.find(function (el) {
      return el.option_analysis;
    });
    // const noTextAnalysis = !text_answers.find((el) => el.analysis);

    return React.createElement("div", {
      key: question_name
    }, React.createElement("div", {
      className: singleAnalysisCard
    }, React.createElement("h3", null, !hide_question_no && "".concat(index + 1, ". "), React.createElement("span", {
      style: {
        color: 'var(--text-color-secondary)'
      }
    }, prefix), React.createElement("span", {
      dangerouslySetInnerHTML: {
        __html: question_name
      }
    })), React.createElement("h4", null, option_answers.map(function (opt) {
      return React.createElement("div", {
        key: opt.option
      }, React.createElement(_Checkbox, {
        disabled: true,
        className: "marginRight5"
      }), React.createElement("span", {
        dangerouslySetInnerHTML: {
          __html: getRichOption(opt)
        }
      }));
    })), React.createElement("div", {
      className: tagTitle
    }, React.createElement(_Tag, {
      color: goodJob ? 'green' : 'red'
    }, React.createElement(IconFont, {
      className: goodJob ? '' : 'redColor',
      type: goodJob ? 'icon-check' : 'icon-wrong',
      style: {
        marginRight: '2px'
      }
    }), getLocalText('your-answer')), React.createElement("span", {
      dangerouslySetInnerHTML: {
        __html: selectedText
      }
    })), correctText && React.createElement("div", {
      className: tagTitle
    }, React.createElement(_Tag, {
      color: "blue"
    }, getLocalText('correct-answer'), " "), React.createElement("span", {
      dangerouslySetInnerHTML: {
        __html: correctText
      }
    })), !!analysis && React.createElement("div", {
      className: tagTitle
    }, React.createElement(_Tag, {
      color: "blue"
    }, getLocalText('answer-analysis'), " "), React.createElement("p", {
      dangerouslySetInnerHTML: {
        __html: analysis
      }
    })), noOptionAnalysis ? '' : React.createElement("div", {
      className: tagTitle
    }, React.createElement(_Tag, {
      color: "blue"
    }, getLocalText('option-analysis'), " "), getOptionAnalysis(option_answers))), React.createElement(_Divider, {
      dashed: true
    }));
  })) : React.createElement(EndingBox, {
    id: "endingBox"
  }, React.createElement(LotteryBox, {
    showLottery: showLottery,
    lotteryInfo: lottery_v3,
    lotteryParams: lotteryParams,
    device: device
  }), !showLottery && React.createElement(_Result, {
    icon: type === 'success' ? React.createElement(IconFont, {
      type: "icon-zhengque",
      color: "var(--primary-color)",
      className: "result"
    }) : React.createElement(IconFont, {
      type: "icon-tishi1",
      color: "var(--primary-color)",
      className: "result"
    }),
    status: type,
    title: title,
    extra: errorCode !== 'forbidden' && React.createElement(React.Fragment, null, React.createElement("div", {
      style: {
        textAlign: 'center',
        color: 'var(--text-color)'
      }
    }, React.createElement("span", {
      dangerouslySetInnerHTML: {
        __html: realPrompt || getLocalText('Submit.thanks')
      }
    }), lottery_url !== undefined && React.createElement("a", {
      href: lottery_url.replace(/<(\/)*p>/g, ''),
      style: {
        marginLeft: 10
      }
    }, React.createElement("div", {
      className: "linkBtn flex alignCenter justifyCenter"
    }, getLocalText('to-lottery'))), lottery_v3 && (lottery_v3 === null || lottery_v3 === void 0 ? void 0 : (_lottery_v3$prizes = lottery_v3.prizes) === null || _lottery_v3$prizes === void 0 ? void 0 : _lottery_v3$prizes.length) && React.createElement("a", {
      style: {
        marginLeft: 10
      },
      onClick: openLottery
    }, React.createElement("div", {
      className: "linkBtn flex alignCenter justifyCenter"
    }, getLocalText('to-lottery'))), lottery_v3 && lottery_v3.has_lottery_draw === 1 && React.createElement("div", {
      style: {
        marginTop: 12
      }
    }, "\u4F60\u5DF2\u53C2\u52A0\u8FC7\u62BD\u5956"), score_analysis && !!score_analysis.length && React.createElement("a", {
      href: "#",
      onClick: showAnswerAnalysis
    }, React.createElement("div", {
      className: "linkBtn flex alignCenter justifyCenter",
      style: {
        cursor: 'pointer'
      }
    }, getLocalText('show-analysis'))), exam_pass === false && React.createElement("a", {
      onClick: function onClick() {
        window.location.reload();
      }
    }, React.createElement("div", {
      className: "linkBtn flex alignCenter justifyCenter",
      style: {
        cursor: 'pointer'
      }
    }, getLocalText('try-again')))), finishImgUrl && React.createElement("div", null, React.createElement("img", {
      style: {
        zoom: finishImgScale || 1,
        height: 'auto',
        width: 'auto',
        maxHeight: 'auto',
        maxWidth: 'auto',
        display: 'block',
        margin: '0 auto'
      },
      src: finishImgUrl,
      loading: "lazy",
      alt: ""
    })))
  }));
});
var AnalysisBox = /*#__PURE__*/styled("div", {
  target: "e1tf5rjv0"
})("padding:15px;overflow:hidden;color:var(--text-color);h2{color:var(--text-color);}");
var EndingBox = /*#__PURE__*/styled("div", {
  target: "e1tf5rjv1"
})("display:flex;flex-direction:column;justify-content:center;.ant-result-icon{position:relative;.iconMask{width:36px;height:36px;border-radius:50%;bottom:18px;right:50%;transform:translateX(18px);z-index:2;position:absolute;background:var(--primary-color);transition:width 0.5s;}}.score{font-size:26px;font-weight:500;font-stretch:normal;font-style:normal;line-height:1.5;letter-spacing:0.2px;color:var(--primary-color);}");
var tagTitle = /*#__PURE__*/css("display:flex;align-items:flex-start;margin-top:10px;white-space:pre-line;word-break:break-all;");
var singleAnalysisCard = /*#__PURE__*/css("padding:10px;border:1px solid var(--ant-bg);border-radius:4px;background:var(--ant-bg);color:var(--text-color);h3,h4{color:var(--text-color);}");